import { ClickAwayListener } from '@material-ui/core'
import React, {
  CSSProperties,
  FunctionComponent,
  MutableRefObject,
  useEffect,
  useRef,
} from 'react'
import { PopperPlacementType } from '@material-ui/core/Popper'
import { is } from '../../MediaQuery'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'
import { SearchPopoverContainer, SearchPopperContainer } from './styled'

const SearchPopover: FunctionComponent<ISearchPopoverProps & IWithSize> = ({
  open,
  size = 1,
  onClose,
  anchorRef,
  children,
  popperOnMobile = false,
  style = {},
  scaleToAnchor = false,
  mouseEvent = 'onMouseUp',
  placement = 'top-start',
  disablePortal = true,
  eventsEnabled = false,
}) => {
  const isMobile = is.mobile()
  const ref = useRef()

  function disableEvents() {
    if (ref.current) {
      ;(ref.current as any).disableEventListeners()
    }
  }

  useEffect(() => {
    document.addEventListener('scroll', disableEvents)
    return () => document.removeEventListener('scroll', disableEvents)
  }, [])

  if (isMobile && !popperOnMobile)
    return (
      <SearchPopoverContainer
        size={size}
        anchorWidth={
          scaleToAnchor &&
          anchorRef.current &&
          anchorRef.current.getBoundingClientRect().width
        }
        open={open}
        anchorEl={anchorRef.current}
        onClose={onClose}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'top',
        }}
        marginThreshold={0}
        anchorPosition={{
          left: 0,
          top: 0,
        }}
        anchorReference={'anchorPosition'}
        BackdropProps={{
          invisible: false,
        }}
        transformOrigin={{
          horizontal: 'left',
          vertical: 'top',
        }}
      >
        {children}
      </SearchPopoverContainer>
    )

  return (
    <ClickAwayListener onClickAway={onClose} mouseEvent={mouseEvent}>
      <SearchPopperContainer
        popperOptions={{
          eventsEnabled: eventsEnabled,
          modifiers: {
            preventOverflow: { boundariesElement: 'viewport', enabled: true },
          },
          positionFixed: false,
        }}
        disablePortal={disablePortal}
        popperRef={ref}
        size={size}
        open={open}
        style={style}
        anchorWidth={
          scaleToAnchor &&
          anchorRef.current &&
          anchorRef.current.getBoundingClientRect().width
        }
        anchorEl={anchorRef.current}
        placement={placement}
        modifiers={{
          flip: { enabled: false },
        }}
      >
        {children}
      </SearchPopperContainer>
    </ClickAwayListener>
  )
}

export default SearchPopover

interface ISearchPopoverProps {
  open: boolean
  onClose?: () => void
  anchorRef: MutableRefObject<HTMLAnchorElement>
  placement?: PopperPlacementType
  scaleToAnchor?: boolean
  popperOnMobile?: boolean
  style?: CSSProperties
  mouseEvent?: 'onClick' | 'onMouseUp' | 'onMouseDown'
  disablePortal?: boolean
  eventsEnabled?: boolean
}
